export const TOUCH_POINTER_TYPE = 'touch';
